import React, { Fragment } from "react";
import { ProgressBar } from "./utilities";
import Print from "@hpo/client/utilities/print/Print";
import { FinancialOverallSection } from "@hpo/client/models/Archive";
import Units from "@hpo/client/utilities/Units";
import smoothJoin from "@hpo/client/utilities/smoothJoin";
import Programs from "@hpo/client/utilities/Programs";

type FinancialOveralProps = {
  payload: FinancialOverallSection;
};

export default function FinancialOveral(props: FinancialOveralProps) {
  const { payload } = props;
  const { periods } = payload;

  return (
    <Fragment>
      <h2>Statistiques générales</h2>
      {periods.length === 1
        ? `Statistiques générales du programme HPO concernent la période ${periods[0]}`
        : `Statistiques générales du programme HPO concernent les périodes ${smoothJoin(periods)}`}
      <table>
        <thead>
          <tr>
            <th>Par appel à projet</th>
            <th>Structures financées</th>
            <th>Projets financées</th>
            <th>Montants conventionnés</th>
            <th>Montants versés</th>
            <th>Taux de consommation</th>
          </tr>
        </thead>
        <tbody>
          {payload.byProgram.map((program) => {
            const { statistics } = program;
            return (
              <tr key={program.key}>
                <td>{Programs[program.key].label}</td>
                <td>{statistics.targetedOrganizations}</td>
                <td>{statistics.targetedProjects}</td>
                <td>{Units.euro.display(statistics.grantedAmount)}</td>
                <td>{Units.euro.display(statistics.certifiedAmount)}</td>
                <td>
                  {Units.percentage.display(statistics.amountsRatio, "-")}
                  <ProgressBar ratio={statistics.amountsRatio} />
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <th>Tous appels à projets confondus</th>
            <th>{payload.allPrograms.targetedOrganizations}</th>
            <th>{payload.allPrograms.targetedProjects}</th>
            <th>{Units.euro.display(payload.allPrograms.grantedAmount)}</th>
            <th>{Units.euro.display(payload.allPrograms.certifiedAmount)}</th>
            <th>
              {Units.percentage.display(payload.allPrograms.amountsRatio, "-")}
              <ProgressBar ratio={payload.allPrograms.amountsRatio} />
            </th>
          </tr>
        </tfoot>
      </table>
      <Print.Space size={0.5} />
      <table>
        <thead>
          <tr>
            <th>Par bénéficiaire</th>
            <th>Projets financées</th>
            <th>Montants conventionnés</th>
            <th>Montants versés</th>
            <th>Taux de consommation</th>
          </tr>
        </thead>
        <tbody>
          {payload.byOrganization.map((org) => {
            const { statistics } = org;
            return (
              <tr key={org.id}>
                <td>{org.label}</td>
                <td>{statistics.targetedProjects}</td>
                <td>{Units.euro.display(statistics.grantedAmount)}</td>
                <td>{Units.euro.display(statistics.certifiedAmount)}</td>
                <td>
                  {Units.percentage.display(statistics.amountsRatio, "-")}
                  <ProgressBar ratio={statistics.amountsRatio} />
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <th>
              {`Tous bénéficiaires (${payload.allOrganizations.targetedOrganizations}) confondus`}
            </th>
            <th>{payload.allOrganizations.targetedProjects}</th>
            <th>
              {Units.euro.display(payload.allOrganizations.grantedAmount)}
            </th>
            <th>
              {Units.euro.display(payload.allOrganizations.certifiedAmount)}
            </th>
            <th>
              {Units.percentage.display(
                payload.allOrganizations.amountsRatio,
                "-",
              )}
              <ProgressBar ratio={payload.allOrganizations.amountsRatio} />
            </th>
          </tr>
        </tfoot>
      </table>
    </Fragment>
  );
}
